<template>
    <div id="first-desk" :style="bg">
        <div id="first-col1">
            <!--github-->
            <div class="first-col-icon" @click="goto('https://github.com/abhipray-cpu')">
              <svg xmlns="http://www.w3.org/2000/svg" width="61" height="62" viewBox="0 0 61 62" fill="none" v-if="theme==1">
                <g filter="url(#filter0_d_17_137)">
                  <path d="M42.9499 53V45.548C43.0363 44.3099 42.888 43.0652 42.5147 41.8967C42.1415 40.7283 41.552 39.6628 40.7853 38.7711C48.0162 37.8623 55.6155 34.7724 55.6155 20.5954C55.6149 16.9702 54.3782 13.4841 52.1613 10.8585C53.211 7.68682 53.1368 4.18111 51.954 1.06957C51.954 1.06957 49.2367 0.160786 42.9499 4.91242C37.6719 3.29952 32.1082 3.29952 26.8301 4.91242C20.5434 0.160786 17.826 1.06957 17.826 1.06957C16.6433 4.18111 16.569 7.68682 17.6188 10.8585C15.3853 13.5035 14.1473 17.0212 14.1645 20.6733C14.1645 34.7465 21.7639 37.8363 28.9948 38.849C28.2371 39.7317 27.6528 40.7844 27.2799 41.9386C26.9069 43.0928 26.7537 44.3226 26.8301 45.548V53" stroke="#3A5A40" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M21.1198 51.5213C14.2113 54.0477 8.45425 51.5213 5 43.7317" stroke="#3A5A40" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                  <filter id="filter0_d_17_137" x="0.249817" y="0.25" width="60.1157" height="61.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_17_137"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_17_137" result="shape"/>
                  </filter>
                </defs>
              </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="61" height="62" viewBox="0 0 61 62" fill="none" v-else>
                    <g filter="url(#filter0_d_13_80)">
                      <path d="M42.9499 53V45.548C43.0363 44.3099 42.888 43.0652 42.5147 41.8967C42.1415 40.7283 41.552 39.6628 40.7853 38.7711C48.0162 37.8623 55.6155 34.7724 55.6155 20.5954C55.6149 16.9702 54.3782 13.4841 52.1613 10.8585C53.211 7.68682 53.1368 4.18111 51.954 1.06957C51.954 1.06957 49.2367 0.160786 42.9499 4.91242C37.6719 3.29952 32.1082 3.29952 26.8301 4.91242C20.5434 0.160786 17.826 1.06957 17.826 1.06957C16.6433 4.18111 16.569 7.68682 17.6188 10.8585C15.3853 13.5035 14.1473 17.0212 14.1645 20.6733C14.1645 34.7465 21.7639 37.8363 28.9948 38.849C28.2371 39.7317 27.6528 40.7844 27.2799 41.9386C26.9069 43.0928 26.7537 44.3226 26.8301 45.548V53" stroke="#DAD7CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M21.1198 51.5214C14.2113 54.0478 8.45425 51.5214 5 43.7318" stroke="#DAD7CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_13_80" x="0.249817" y="0.25" width="60.1157" height="61.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_80"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_80" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
    
                 
            </div>
            <!--linkedin-->
            <div class="first-col-icon" @click="goto('https://www.linkedin.com/in/abhipray-dumka-92963a165/')">
              <svg xmlns="http://www.w3.org/2000/svg" width="57" height="60" viewBox="0 0 57 60" fill="none" v-if="theme==1">
                <g filter="url(#filter0_d_17_142)">
                  <path d="M49.3768 0.000363555H7.62324C7.15389 -0.00651236 6.68785 0.0842059 6.25175 0.267338C5.81564 0.450469 5.418 0.722427 5.08154 1.06768C4.74509 1.41293 4.4764 1.82472 4.29083 2.27952C4.10525 2.73432 4.00643 3.22322 4 3.71831V48.2817C4.00643 48.7768 4.10525 49.2657 4.29083 49.7205C4.4764 50.1753 4.74509 50.5871 5.08154 50.9323C5.418 51.2776 5.81564 51.5495 6.25175 51.7327C6.68785 51.9158 7.15389 52.0065 7.62324 51.9996H49.3768C49.8461 52.0065 50.3121 51.9158 50.7483 51.7327C51.1844 51.5495 51.582 51.2776 51.9185 50.9323C52.2549 50.5871 52.5236 50.1753 52.7092 49.7205C52.8947 49.2657 52.9936 48.7768 53 48.2817V3.71831C52.9936 3.22322 52.8947 2.73432 52.7092 2.27952C52.5236 1.82472 52.2549 1.41293 51.9185 1.06768C51.582 0.722427 51.1844 0.450469 50.7483 0.267338C50.3121 0.0842059 49.8461 -0.00651236 49.3768 0.000363555ZM18.8627 43.5238H11.4683V20.1241H18.8627V43.5238ZM15.1655 16.8481C14.1457 16.8481 13.1677 16.4208 12.4466 15.6602C11.7255 14.8995 11.3204 13.8679 11.3204 12.7922C11.3204 11.7165 11.7255 10.6848 12.4466 9.9242C13.1677 9.16356 14.1457 8.73624 15.1655 8.73624C15.707 8.67146 16.2554 8.72806 16.7747 8.90234C17.294 9.07661 17.7726 9.36463 18.1791 9.74753C18.5856 10.1304 18.9108 10.5996 19.1335 11.1243C19.3562 11.6489 19.4713 12.2173 19.4713 12.7922C19.4713 13.367 19.3562 13.9354 19.1335 14.4601C18.9108 14.9848 18.5856 15.4539 18.1791 15.8368C17.7726 16.2197 17.294 16.5078 16.7747 16.682C16.2554 16.8563 15.707 16.9129 15.1655 16.8481ZM45.5317 43.5238H38.1373V30.9659C38.1373 27.82 37.0775 25.766 34.3908 25.766C33.5594 25.7724 32.7498 26.0475 32.0711 26.5542C31.3924 27.061 30.8773 27.7749 30.5951 28.6C30.4022 29.2111 30.3186 29.8546 30.3486 30.4979V43.4978H22.9542V20.0981H30.3486V23.4C31.0203 22.1705 31.9973 21.1576 33.1743 20.4704C34.3513 19.7832 35.6838 19.4477 37.0282 19.5001C41.9577 19.5001 45.5317 22.854 45.5317 30.0559V43.5238Z" fill="#3A5A40"/>
                </g>
                <defs>
                  <filter id="filter0_d_17_142" x="0" y="0" width="57" height="60" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_17_142"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_17_142" result="shape"/>
                  </filter>
                </defs>
              </svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="57" height="60" viewBox="0 0 57 60" fill="none" v-else>
                    <g filter="url(#filter0_d_13_85)">
                      <path d="M49.3768 0.000363555H7.62324C7.15389 -0.00651236 6.68785 0.0842059 6.25175 0.267338C5.81564 0.450469 5.418 0.722427 5.08154 1.06768C4.74509 1.41293 4.4764 1.82472 4.29083 2.27952C4.10525 2.73432 4.00643 3.22322 4 3.71831V48.2817C4.00643 48.7768 4.10525 49.2657 4.29083 49.7205C4.4764 50.1753 4.74509 50.5871 5.08154 50.9323C5.418 51.2776 5.81564 51.5495 6.25175 51.7327C6.68785 51.9158 7.15389 52.0065 7.62324 51.9996H49.3768C49.8461 52.0065 50.3121 51.9158 50.7483 51.7327C51.1844 51.5495 51.582 51.2776 51.9185 50.9323C52.2549 50.5871 52.5236 50.1753 52.7092 49.7205C52.8947 49.2657 52.9936 48.7768 53 48.2817V3.71831C52.9936 3.22322 52.8947 2.73432 52.7092 2.27952C52.5236 1.82472 52.2549 1.41293 51.9185 1.06768C51.582 0.722427 51.1844 0.450469 50.7483 0.267338C50.3121 0.0842059 49.8461 -0.00651236 49.3768 0.000363555ZM18.8627 43.5238H11.4683V20.1241H18.8627V43.5238ZM15.1655 16.8481C14.1457 16.8481 13.1677 16.4208 12.4466 15.6602C11.7255 14.8995 11.3204 13.8679 11.3204 12.7922C11.3204 11.7165 11.7255 10.6848 12.4466 9.9242C13.1677 9.16356 14.1457 8.73624 15.1655 8.73624C15.707 8.67146 16.2554 8.72806 16.7747 8.90234C17.294 9.07661 17.7726 9.36463 18.1791 9.74753C18.5856 10.1304 18.9108 10.5996 19.1335 11.1243C19.3562 11.6489 19.4713 12.2173 19.4713 12.7922C19.4713 13.367 19.3562 13.9354 19.1335 14.4601C18.9108 14.9848 18.5856 15.4539 18.1791 15.8368C17.7726 16.2197 17.294 16.5078 16.7747 16.682C16.2554 16.8563 15.707 16.9129 15.1655 16.8481ZM45.5317 43.5238H38.1373V30.9659C38.1373 27.82 37.0775 25.766 34.3908 25.766C33.5594 25.7724 32.7498 26.0475 32.0711 26.5542C31.3924 27.061 30.8773 27.7749 30.5951 28.6C30.4022 29.2111 30.3186 29.8546 30.3486 30.4979V43.4978H22.9542V20.0981H30.3486V23.4C31.0203 22.1705 31.9973 21.1576 33.1743 20.4704C34.3513 19.7832 35.6838 19.4477 37.0282 19.5001C41.9577 19.5001 45.5317 22.854 45.5317 30.0559V43.5238Z" fill="#DAD7CD"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_13_85" x="0" y="0" width="57" height="60" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_85"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_85" result="shape"/>
                      </filter>
                    </defs>
                  </svg>

                 
            </div>
            <!--instagram-->
           <div class="first-col-icon" @click="goto('https://www.instagram.com/abhipra_dumka/')">
            <svg xmlns="http://www.w3.org/2000/svg" width="59" height="60" viewBox="0 0 59 60" fill="none" v-if="theme==1">
              <g filter="url(#filter0_d_17_140)">
                <path d="M29.5 18.2C27.4711 18.2 25.5253 19.0218 24.0906 20.4846C22.656 21.9473 21.85 23.9313 21.85 26C21.85 28.0687 22.656 30.0526 24.0906 31.5154C25.5253 32.9782 27.4711 33.8 29.5 33.8C31.5289 33.8 33.4747 32.9782 34.9094 31.5154C36.344 30.0526 37.15 28.0687 37.15 26C37.15 23.9313 36.344 21.9473 34.9094 20.4846C33.4747 19.0218 31.5289 18.2 29.5 18.2ZM29.5 13C32.8815 13 36.1245 14.3696 38.5156 16.8076C40.9067 19.2456 42.25 22.5522 42.25 26C42.25 29.4478 40.9067 32.7544 38.5156 35.1924C36.1245 37.6304 32.8815 39 29.5 39C26.1185 39 22.8755 37.6304 20.4844 35.1924C18.0933 32.7544 16.75 29.4478 16.75 26C16.75 22.5522 18.0933 19.2456 20.4844 16.8076C22.8755 14.3696 26.1185 13 29.5 13ZM46.075 12.35C46.075 13.212 45.7392 14.0386 45.1414 14.6481C44.5436 15.2576 43.7329 15.6 42.8875 15.6C42.0421 15.6 41.2314 15.2576 40.6336 14.6481C40.0358 14.0386 39.7 13.212 39.7 12.35C39.7 11.488 40.0358 10.6614 40.6336 10.0519C41.2314 9.44241 42.0421 9.1 42.8875 9.1C43.7329 9.1 44.5436 9.44241 45.1414 10.0519C45.7392 10.6614 46.075 11.488 46.075 12.35ZM29.5 5.2C23.1913 5.2 22.1611 5.2182 19.2261 5.3508C17.2269 5.447 15.8855 5.72 14.6411 6.214C13.5998 6.60384 12.6583 7.22868 11.8871 8.0418C11.089 8.82804 10.4754 9.78792 10.0919 10.8498C9.60745 12.1238 9.3397 13.4888 9.2479 15.5246C9.1153 18.395 9.09745 19.3986 9.09745 26C9.09745 32.435 9.1153 33.4828 9.24535 36.4754C9.3397 38.5112 9.60745 39.8814 10.0894 41.1476C10.5229 42.2786 11.0329 43.0924 11.8795 43.9556C12.7389 44.8292 13.537 45.3518 14.6335 45.7834C15.8932 46.28 17.2345 46.5556 19.2235 46.6492C22.0387 46.7844 23.023 46.8 29.4975 46.8C35.8087 46.8 36.8363 46.7818 39.7714 46.6492C41.7655 46.553 43.1068 46.28 44.3538 45.7886C45.3942 45.3968 46.3353 44.7723 47.1077 43.9608C47.9671 43.0872 48.4797 42.2734 48.903 41.1528C49.3875 39.8736 49.6577 38.506 49.7495 36.4728C49.8821 33.605 49.8974 32.5988 49.8974 26C49.8974 19.5676 49.8796 18.5172 49.7495 15.5246C49.6552 13.4914 49.3849 12.1186 48.903 10.8498C48.5186 9.78904 47.906 8.82955 47.1103 8.0418C46.3395 7.2276 45.398 6.60183 44.3563 6.2114C43.1068 5.7174 41.7655 5.4444 39.7714 5.3508C36.9587 5.2156 35.977 5.2 29.5 5.2ZM29.5 0C36.4283 0 37.2928 0.0259998 40.0137 0.156C42.7269 0.286 44.5782 0.7202 46.2025 1.365C47.8855 2.0254 49.3033 2.9198 50.7211 4.3628C52.0178 5.66253 53.0211 7.23473 53.6613 8.97C54.2911 10.6262 54.7195 12.5138 54.847 15.2828C54.9669 18.0544 55 18.9358 55 26C55 33.0642 54.9745 33.9456 54.847 36.7172C54.7195 39.4862 54.2911 41.3712 53.6613 43.03C53.0229 44.7662 52.0193 46.3387 50.7211 47.6372C49.446 48.9588 47.9041 49.9818 46.2025 50.635C44.5782 51.2772 42.7269 51.714 40.0137 51.844C37.2928 51.9662 36.4283 52 29.5 52C22.5716 52 21.7072 51.974 18.9863 51.844C16.2731 51.714 14.4244 51.2772 12.7975 50.635C11.0949 49.9836 9.55269 48.9605 8.2789 47.6372C6.98205 46.3376 5.9787 44.7654 5.33875 43.03C4.70635 41.3738 4.2805 39.4862 4.153 36.7172C4.0306 33.9456 4 33.0642 4 26C4 18.9358 4.0255 18.0544 4.153 15.2828C4.2805 12.5112 4.70635 10.6288 5.33875 8.97C5.97685 7.23367 6.98045 5.66103 8.2789 4.3628C9.55306 3.04 11.0952 2.0169 12.7975 1.365C14.4219 0.7202 16.2706 0.286 18.9863 0.156C21.7072 0.0337999 22.5716 0 29.5 0Z" fill="#3A5A40"/>
              </g>
              <defs>
                <filter id="filter0_d_17_140" x="0" y="0" width="59" height="60" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                  <feOffset dy="4"/>
                  <feGaussianBlur stdDeviation="2"/>
                  <feComposite in2="hardAlpha" operator="out"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_17_140"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_17_140" result="shape"/>
                </filter>
              </defs>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="59" height="60" viewBox="0 0 59 60" fill="none" v-else>
                <g filter="url(#filter0_d_13_83)">
                  <path d="M29.5 18.2C27.4711 18.2 25.5253 19.0218 24.0906 20.4846C22.656 21.9473 21.85 23.9313 21.85 26C21.85 28.0687 22.656 30.0526 24.0906 31.5154C25.5253 32.9782 27.4711 33.8 29.5 33.8C31.5289 33.8 33.4747 32.9782 34.9094 31.5154C36.344 30.0526 37.15 28.0687 37.15 26C37.15 23.9313 36.344 21.9473 34.9094 20.4846C33.4747 19.0218 31.5289 18.2 29.5 18.2ZM29.5 13C32.8815 13 36.1245 14.3696 38.5156 16.8076C40.9067 19.2456 42.25 22.5522 42.25 26C42.25 29.4478 40.9067 32.7544 38.5156 35.1924C36.1245 37.6304 32.8815 39 29.5 39C26.1185 39 22.8755 37.6304 20.4844 35.1924C18.0933 32.7544 16.75 29.4478 16.75 26C16.75 22.5522 18.0933 19.2456 20.4844 16.8076C22.8755 14.3696 26.1185 13 29.5 13ZM46.075 12.35C46.075 13.212 45.7392 14.0386 45.1414 14.6481C44.5436 15.2576 43.7329 15.6 42.8875 15.6C42.0421 15.6 41.2314 15.2576 40.6336 14.6481C40.0358 14.0386 39.7 13.212 39.7 12.35C39.7 11.488 40.0358 10.6614 40.6336 10.0519C41.2314 9.44241 42.0421 9.1 42.8875 9.1C43.7329 9.1 44.5436 9.44241 45.1414 10.0519C45.7392 10.6614 46.075 11.488 46.075 12.35ZM29.5 5.2C23.1913 5.2 22.1611 5.2182 19.2261 5.3508C17.2269 5.447 15.8855 5.72 14.6411 6.214C13.5998 6.60384 12.6583 7.22868 11.8871 8.0418C11.089 8.82804 10.4754 9.78792 10.0919 10.8498C9.60745 12.1238 9.3397 13.4888 9.2479 15.5246C9.1153 18.395 9.09745 19.3986 9.09745 26C9.09745 32.435 9.1153 33.4828 9.24535 36.4754C9.3397 38.5112 9.60745 39.8814 10.0894 41.1476C10.5229 42.2786 11.0329 43.0924 11.8795 43.9556C12.7389 44.8292 13.537 45.3518 14.6335 45.7834C15.8932 46.28 17.2345 46.5556 19.2235 46.6492C22.0387 46.7844 23.023 46.8 29.4975 46.8C35.8087 46.8 36.8363 46.7818 39.7714 46.6492C41.7655 46.553 43.1068 46.28 44.3538 45.7886C45.3942 45.3968 46.3353 44.7723 47.1077 43.9608C47.9671 43.0872 48.4797 42.2734 48.903 41.1528C49.3875 39.8736 49.6577 38.506 49.7495 36.4728C49.8821 33.605 49.8974 32.5988 49.8974 26C49.8974 19.5676 49.8796 18.5172 49.7495 15.5246C49.6552 13.4914 49.3849 12.1186 48.903 10.8498C48.5186 9.78904 47.906 8.82955 47.1103 8.0418C46.3395 7.2276 45.398 6.60183 44.3563 6.2114C43.1068 5.7174 41.7655 5.4444 39.7714 5.3508C36.9587 5.2156 35.977 5.2 29.5 5.2ZM29.5 0C36.4283 0 37.2928 0.0259998 40.0137 0.156C42.7269 0.286 44.5782 0.7202 46.2025 1.365C47.8855 2.0254 49.3033 2.9198 50.7211 4.3628C52.0178 5.66253 53.0211 7.23473 53.6613 8.97C54.2911 10.6262 54.7195 12.5138 54.847 15.2828C54.9669 18.0544 55 18.9358 55 26C55 33.0642 54.9745 33.9456 54.847 36.7172C54.7195 39.4862 54.2911 41.3712 53.6613 43.03C53.0229 44.7662 52.0193 46.3387 50.7211 47.6372C49.446 48.9588 47.9041 49.9818 46.2025 50.635C44.5782 51.2772 42.7269 51.714 40.0137 51.844C37.2928 51.9662 36.4283 52 29.5 52C22.5716 52 21.7072 51.974 18.9863 51.844C16.2731 51.714 14.4244 51.2772 12.7975 50.635C11.0949 49.9836 9.55269 48.9605 8.2789 47.6372C6.98205 46.3376 5.9787 44.7654 5.33875 43.03C4.70635 41.3738 4.2805 39.4862 4.153 36.7172C4.0306 33.9456 4 33.0642 4 26C4 18.9358 4.0255 18.0544 4.153 15.2828C4.2805 12.5112 4.70635 10.6288 5.33875 8.97C5.97685 7.23367 6.98045 5.66103 8.2789 4.3628C9.55306 3.04 11.0952 2.0169 12.7975 1.365C14.4219 0.7202 16.2706 0.286 18.9863 0.156C21.7072 0.0337999 22.5716 0 29.5 0Z" fill="#DAD7CD"/>
                </g>
                <defs>
                  <filter id="filter0_d_13_83" x="0" y="0" width="59" height="60" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_83"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_83" result="shape"/>
                  </filter>
                </defs>
              </svg>
              
              
           </div>
           <!--gmail-->
           <div class="first-col-icon" @click="sendMail">
            <svg xmlns="http://www.w3.org/2000/svg" width="57" height="51" viewBox="0 0 57 51" fill="none" v-if="theme==1">
              <g filter="url(#filter0_d_17_141)">
                <path d="M48.1 37.625H43.2V14.1094L28.5 24.1875L13.8 14.1094V37.625H8.9V5.375H11.84L28.5 16.7969L45.16 5.375H48.1M48.1 0H8.9C6.1805 0 4 2.39188 4 5.375V37.625C4 39.0505 4.51625 40.4177 5.43518 41.4257C6.3541 42.4337 7.60044 43 8.9 43H48.1C49.3996 43 50.6459 42.4337 51.5648 41.4257C52.4838 40.4177 53 39.0505 53 37.625V5.375C53 3.94946 52.4838 2.58231 51.5648 1.5743C50.6459 0.566293 49.3996 0 48.1 0Z" fill="#3A5A40"/>
              </g>
              <defs>
                <filter id="filter0_d_17_141" x="0" y="0" width="57" height="51" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                  <feOffset dy="4"/>
                  <feGaussianBlur stdDeviation="2"/>
                  <feComposite in2="hardAlpha" operator="out"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_17_141"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_17_141" result="shape"/>
                </filter>
              </defs>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="57" height="51" viewBox="0 0 57 51" fill="none" v-else>
                <g filter="url(#filter0_d_13_84)">
                  <path d="M48.1 37.625H43.2V14.1094L28.5 24.1875L13.8 14.1094V37.625H8.9V5.375H11.84L28.5 16.7969L45.16 5.375H48.1M48.1 0H8.9C6.1805 0 4 2.39188 4 5.375V37.625C4 39.0505 4.51625 40.4177 5.43518 41.4257C6.3541 42.4337 7.60044 43 8.9 43H48.1C49.3996 43 50.6459 42.4337 51.5648 41.4257C52.4838 40.4177 53 39.0505 53 37.625V5.375C53 3.94946 52.4838 2.58231 51.5648 1.5743C50.6459 0.566293 49.3996 0 48.1 0Z" fill="#DAD7CD"/>
                </g>
                <defs>
                  <filter id="filter0_d_13_84" x="0" y="0" width="57" height="51" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_84"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_84" result="shape"/>
                  </filter>
                </defs>
              </svg>
              
           </div>
           <div class="first-col-icon" @click="goto('https://dumkaabhipray.wixsite.com/avi-talks')">
            <svg xmlns="http://www.w3.org/2000/svg" width="59" height="59" viewBox="0 0 59 59" fill="none" v-if="theme==1">
              <g filter="url(#filter0_d_253_10)">
                <path d="M22.4886 18.6699C23.0351 18.1119 23.1944 18.0891 26.6326 18.0891C29.7292 18.0891 29.8317 18.1005 30.287 18.3282C30.9474 18.6585 31.232 19.1253 31.232 19.8769C31.232 20.5487 30.9587 21.0155 30.3667 21.4027C30.048 21.6076 29.8544 21.619 26.8261 21.6418C24.9591 21.6532 23.4677 21.619 23.24 21.5507C22.0674 21.2205 21.6347 19.5352 22.4886 18.6699ZM29.4787 29.4304C23.3424 29.4304 23.1261 29.4532 22.6252 29.8972C22.2267 30.2502 21.9763 30.9676 22.0446 31.48C22.1243 32.0152 22.5911 32.6301 23.092 32.8464C23.3424 32.9603 24.6972 33.04 29.5015 32.9831L34.9547 32.9147L36.0021 32.7439C37.0267 32.1632 37.1975 30.7626 36.355 29.9656C35.7517 29.4304 35.7858 29.4304 29.4787 29.4304ZM54.9119 44.2446C54.5135 47.4785 52.2935 49.9836 49.0944 50.792C48.2747 50.997 47.9901 51.0084 29.4104 50.997C11.4455 50.997 10.5234 50.9856 9.82892 50.792C8.87261 50.5415 8.05292 50.1657 7.29015 49.6533C6.65261 49.2206 5.70769 48.3097 5.35477 47.7859C4.92215 47.1482 4.42123 46.0437 4.21631 45.2808C4.01138 44.5179 4 44.2104 4 25.5361C4 6.96422 4 6.56568 4.20492 5.75722C4.92215 2.94468 7.15353 0.792577 10.0338 0.154916C10.8649 -0.0272728 47.8421 -0.0614336 48.7415 0.120755C51.155 0.610388 53.0563 2.0679 54.1606 4.26555C55.0372 6.00773 54.9575 4.09475 54.9916 24.8301C55.0144 38.016 54.9916 43.5614 54.9119 44.2446ZM45.1895 23.1563C45.0643 22.5869 44.7113 22.0631 44.3129 21.8468C44.1876 21.7784 43.4021 21.6987 42.5483 21.6532C41.1366 21.5849 40.9772 21.5621 40.5218 21.3002C39.816 20.8903 39.6224 20.4348 39.611 19.2164C39.611 16.8935 38.6433 14.73 36.7307 12.7829C35.3646 11.3937 33.8504 10.4486 32.1086 9.92479C31.6987 9.79954 30.7652 9.75399 27.6458 9.71983C22.7618 9.66289 21.6689 9.76538 20.0068 10.4258C16.9329 11.6442 14.7357 14.229 13.9274 17.5312C13.7794 18.1461 13.7452 19.1481 13.7111 24.8529C13.6655 32.0038 13.7111 33.0628 14.1664 34.4747C15.2708 37.9705 18.3901 40.5553 21.5209 41.1246C22.5683 41.3182 35.4329 41.3637 36.7421 41.1816C39.0304 40.8741 40.8292 39.9518 42.5141 38.2324C43.7323 36.9912 44.495 35.6362 44.996 33.8485C45.3603 32.6073 45.3261 23.7825 45.1895 23.1563Z" fill="#3A5A40"/>
              </g>
              <defs>
                <filter id="filter0_d_253_10" x="0" y="0" width="59" height="59" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                  <feOffset dy="4"/>
                  <feGaussianBlur stdDeviation="2"/>
                  <feComposite in2="hardAlpha" operator="out"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_253_10"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_253_10" result="shape"/>
                </filter>
              </defs>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="59" height="59" viewBox="0 0 59 59" fill="none" v-else>
              <g filter="url(#filter0_d_253_9)">
                <path d="M22.4886 18.6699C23.0351 18.1119 23.1944 18.0891 26.6326 18.0891C29.7292 18.0891 29.8317 18.1005 30.287 18.3282C30.9474 18.6585 31.232 19.1253 31.232 19.8769C31.232 20.5487 30.9587 21.0155 30.3667 21.4027C30.048 21.6076 29.8544 21.619 26.8261 21.6418C24.9591 21.6532 23.4677 21.619 23.24 21.5507C22.0674 21.2205 21.6347 19.5352 22.4886 18.6699ZM29.4787 29.4304C23.3424 29.4304 23.1261 29.4532 22.6252 29.8972C22.2267 30.2502 21.9763 30.9676 22.0446 31.48C22.1243 32.0152 22.5911 32.6301 23.092 32.8464C23.3424 32.9603 24.6972 33.04 29.5015 32.9831L34.9547 32.9147L36.0021 32.7439C37.0267 32.1632 37.1975 30.7626 36.355 29.9656C35.7517 29.4304 35.7858 29.4304 29.4787 29.4304ZM54.9119 44.2446C54.5135 47.4785 52.2935 49.9836 49.0944 50.792C48.2747 50.997 47.9901 51.0084 29.4104 50.997C11.4455 50.997 10.5234 50.9856 9.82892 50.792C8.87261 50.5415 8.05292 50.1657 7.29015 49.6533C6.65261 49.2206 5.70769 48.3097 5.35477 47.7859C4.92215 47.1482 4.42123 46.0437 4.21631 45.2808C4.01138 44.5179 4 44.2104 4 25.5361C4 6.96422 4 6.56568 4.20492 5.75722C4.92215 2.94468 7.15353 0.792577 10.0338 0.154916C10.8649 -0.0272728 47.8421 -0.0614336 48.7415 0.120755C51.155 0.610388 53.0563 2.0679 54.1606 4.26555C55.0372 6.00773 54.9575 4.09475 54.9916 24.8301C55.0144 38.016 54.9916 43.5614 54.9119 44.2446ZM45.1895 23.1563C45.0643 22.5869 44.7113 22.0631 44.3129 21.8468C44.1876 21.7784 43.4021 21.6987 42.5483 21.6532C41.1366 21.5849 40.9772 21.5621 40.5218 21.3002C39.816 20.8903 39.6224 20.4348 39.611 19.2164C39.611 16.8935 38.6433 14.73 36.7307 12.7829C35.3646 11.3937 33.8504 10.4486 32.1086 9.92479C31.6987 9.79954 30.7652 9.75399 27.6458 9.71983C22.7618 9.66289 21.6689 9.76538 20.0068 10.4258C16.9329 11.6442 14.7357 14.229 13.9274 17.5312C13.7794 18.1461 13.7452 19.1481 13.7111 24.8529C13.6655 32.0038 13.7111 33.0628 14.1664 34.4747C15.2708 37.9705 18.3901 40.5553 21.5209 41.1246C22.5683 41.3182 35.4329 41.3637 36.7421 41.1816C39.0304 40.8741 40.8292 39.9518 42.5141 38.2324C43.7323 36.9912 44.495 35.6362 44.996 33.8485C45.3603 32.6073 45.3261 23.7825 45.1895 23.1563Z" fill="#DAD7CD"/>
              </g>
              <defs>
                <filter id="filter0_d_253_9" x="0" y="0" width="59" height="59" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                  <feOffset dy="4"/>
                  <feGaussianBlur stdDeviation="2"/>
                  <feComposite in2="hardAlpha" operator="out"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_253_9"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_253_9" result="shape"/>
                </filter>
              </defs>
            </svg>
              
           </div>
        </div>
        <div id="first-col2">
            <h2 :class="theme==1?'intro-text-2':'intro-text-1'">Hi I'm</h2>
            <h2 :class="theme==0?'intro-name-1':theme==1?'intro-name-2':'intro-name-3'">Abhipray</h2>
            <h3 :class="theme==1?'intro-h3-2':'intro-h3-1'">A FullStack Dev and tech enthusiast, I craft magic with every key press.</h3>
            <h3 :class="theme==1?'intro-h3-2':'intro-h3-1'">Guided by Hardwork, Humor, and Happiness, I shape digital realms. </h3>
            <h3 :class="theme==1?'intro-h3-2':'intro-h3-1'">
              Together, let's sculpt the future of tech in code and creativity.
            </h3>
            <div :class="theme==0?'first-btn1':theme==1?'first-btn2':theme==2?'first-btn3':'first-btn4'" @click="$emit('go-to','sixth-page')">
                <h3>Let's Connect</h3>
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="37" viewBox="0 0 44 37" fill="none" v-if="theme==0">
                    <g filter="url(#filter0_d_13_94)">
                      <path d="M4.45542 0.245968C4.64748 0.114699 4.88316 0.0317638 5.13322 0.00745869C5.38327 -0.0168464 5.63668 0.0185496 5.86198 0.109252L39.2904 13.5737C39.5037 13.6599 39.683 13.7921 39.8083 13.9556C39.9336 14.1191 40 14.3075 40 14.4997C40 14.6919 39.9336 14.8803 39.8083 15.0438C39.683 15.2073 39.5037 15.3395 39.2904 15.4256L5.86198 28.8901C5.63684 28.9811 5.38349 29.0167 5.1334 28.9927C4.88331 28.9687 4.64749 28.886 4.45521 28.7549C4.26294 28.6239 4.12269 28.4502 4.05187 28.2555C3.98105 28.0608 3.98278 27.8536 4.05685 27.6597L9.08397 14.4997L4.05685 1.3397C3.98321 1.14597 3.98172 0.939097 4.05256 0.744691C4.1234 0.550286 4.26347 0.376888 4.45542 0.245968ZM11.3777 15.5354L7.39969 25.9549L35.8395 14.4997L7.39969 3.04451L11.3777 13.464H25.8573C26.1983 13.464 26.5253 13.5731 26.7664 13.7673C27.0076 13.9616 27.143 14.225 27.143 14.4997C27.143 14.7744 27.0076 15.0378 26.7664 15.2321C26.5253 15.4263 26.1983 15.5354 25.8573 15.5354H11.3777Z" fill="#344E41"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_13_94" x="0" y="0" width="44" height="37" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_94"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_94" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="37" viewBox="0 0 44 37" fill="none" v-if='theme==1'>
                    <g filter="url(#filter0_d_17_151)">
                      <path d="M4.45542 0.245968C4.64748 0.114699 4.88316 0.0317638 5.13322 0.00745869C5.38327 -0.0168464 5.63668 0.0185496 5.86198 0.109252L39.2904 13.5737C39.5037 13.6599 39.683 13.7921 39.8083 13.9556C39.9336 14.1191 40 14.3075 40 14.4997C40 14.6919 39.9336 14.8803 39.8083 15.0438C39.683 15.2073 39.5037 15.3395 39.2904 15.4256L5.86198 28.8901C5.63684 28.9811 5.38349 29.0167 5.1334 28.9927C4.88331 28.9687 4.64749 28.886 4.45521 28.7549C4.26294 28.6239 4.12269 28.4502 4.05187 28.2555C3.98105 28.0608 3.98278 27.8536 4.05685 27.6597L9.08397 14.4997L4.05685 1.3397C3.98321 1.14597 3.98172 0.939097 4.05256 0.744691C4.1234 0.550286 4.26347 0.376888 4.45542 0.245968ZM11.3777 15.5354L7.39969 25.9549L35.8395 14.4997L7.39969 3.04451L11.3777 13.464H25.8573C26.1983 13.464 26.5253 13.5731 26.7664 13.7673C27.0076 13.9616 27.143 14.225 27.143 14.4997C27.143 14.7744 27.0076 15.0378 26.7664 15.2321C26.5253 15.4263 26.1983 15.5354 25.8573 15.5354H11.3777Z" fill="#A3B18A"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_17_151" x="0" y="0" width="44" height="37" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_17_151"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_17_151" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="37" viewBox="0 0 44 37" fill="none" v-if="theme==2">
  <g filter="url(#filter0_d_227_92)">
    <path d="M4.45542 0.245968C4.64748 0.114699 4.88316 0.0317638 5.13322 0.00745869C5.38327 -0.0168464 5.63668 0.0185496 5.86198 0.109252L39.2904 13.5737C39.5037 13.6599 39.683 13.7921 39.8083 13.9556C39.9336 14.1191 40 14.3075 40 14.4997C40 14.6919 39.9336 14.8803 39.8083 15.0438C39.683 15.2073 39.5037 15.3395 39.2904 15.4256L5.86198 28.8901C5.63684 28.9811 5.38349 29.0167 5.1334 28.9927C4.88331 28.9687 4.64749 28.886 4.45521 28.7549C4.26294 28.6239 4.12269 28.4502 4.05187 28.2555C3.98105 28.0608 3.98278 27.8536 4.05685 27.6597L9.08397 14.4997L4.05685 1.3397C3.98321 1.14597 3.98172 0.939097 4.05256 0.744691C4.1234 0.550286 4.26347 0.376888 4.45542 0.245968ZM11.3777 15.5354L7.39969 25.9549L35.8395 14.4997L7.39969 3.04451L11.3777 13.464H25.8573C26.1983 13.464 26.5253 13.5731 26.7664 13.7673C27.0076 13.9616 27.143 14.225 27.143 14.4997C27.143 14.7744 27.0076 15.0378 26.7664 15.2321C26.5253 15.4263 26.1983 15.5354 25.8573 15.5354H11.3777Z" fill="#1D267D"/>
  </g>
  <defs>
    <filter id="filter0_d_227_92" x="0" y="0" width="44" height="37" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_227_92"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_227_92" result="shape"/>
    </filter>
  </defs>
                   </svg>
                   <svg xmlns="http://www.w3.org/2000/svg" width="44" height="37" viewBox="0 0 44 37" fill="none" v-if="theme==3">
  <g filter="url(#filter0_d_227_91)">
    <path d="M4.45542 0.245968C4.64748 0.114699 4.88316 0.0317638 5.13322 0.00745869C5.38327 -0.0168464 5.63668 0.0185496 5.86198 0.109252L39.2904 13.5737C39.5037 13.6599 39.683 13.7921 39.8083 13.9556C39.9336 14.1191 40 14.3075 40 14.4997C40 14.6919 39.9336 14.8803 39.8083 15.0438C39.683 15.2073 39.5037 15.3395 39.2904 15.4256L5.86198 28.8901C5.63684 28.9811 5.38349 29.0167 5.1334 28.9927C4.88331 28.9687 4.64749 28.886 4.45521 28.7549C4.26294 28.6239 4.12269 28.4502 4.05187 28.2555C3.98105 28.0608 3.98278 27.8536 4.05685 27.6597L9.08397 14.4997L4.05685 1.3397C3.98321 1.14597 3.98172 0.939097 4.05256 0.744691C4.1234 0.550286 4.26347 0.376888 4.45542 0.245968ZM11.3777 15.5354L7.39969 25.9549L35.8395 14.4997L7.39969 3.04451L11.3777 13.464H25.8573C26.1983 13.464 26.5253 13.5731 26.7664 13.7673C27.0076 13.9616 27.143 14.225 27.143 14.4997C27.143 14.7744 27.0076 15.0378 26.7664 15.2321C26.5253 15.4263 26.1983 15.5354 25.8573 15.5354H11.3777Z" fill="#0C134F"/>
  </g>
  <defs>
    <filter id="filter0_d_227_91" x="0" y="0" width="44" height="37" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dy="4"/>
      <feGaussianBlur stdDeviation="2"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_227_91"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_227_91" result="shape"/>
    </filter>
  </defs>
                     </svg>

            </div>
        </div>
        <div id="first-col3">
          <img :src="image1" alt="dp"> 
        </div>
    </div>
</template>

<script>
export default {
  data(){
    return{
            image1:"https://firebasestorage.googleapis.com/v0/b/portfolio-b3f3a.appspot.com/o/images%2Fdp.jpeg?alt=media&token=0b2c2f11-236e-42ef-93b2-4d0fd0dff318",
    }
  },
    computed:{
        bg(){
          let theme = this.$store.getters['getTheme']
            if(theme==0){
                return `background:#344E41`
            }
            else if(theme==1){
                return `background:#A3B18A`
            }
            else if(theme==2){
              return 'background:#0C134F'
            }
            else if(theme==3){
              return 'background:#1D267D'
            }
            else{
              return `background:#344E41`
            }
        },
        text(){
            let theme = this.$store.getters['getTheme']
            if(theme==0){
                return `color:#344E41`
            }
            else{
                return `color:`
            }
        },
        theme(){
            return this.$store.getters['getTheme']
        },

    },
    methods:{
      goto(val){
        window.open(val, '_blank');

      },
      sendMail(){
        window.location.href = `mailto:dumkaabhipray@gmail.com`;
      }
    }
}
</script>

<style scoped>
@media only screen and (max-width:480px){
  #first-desk{
      display: none;
  }
}
@media only screen and (min-width:481px) and (max-width:960px){
  #first-desk{
    width:100vw;
    position: relative;
    overflow-x:hidden;
    overflow-y:auto;
    margin-top:4vh;
    display: grid;
    grid-template-columns: 15vw 60vw 25vw;
    }
    #first-desk::-webkit-scrollbar{
    display: none;
    }
    #first-col1{
        width:13vw;
        height:fit-content;
        padding-left:2vw;
        padding-top:1vh;
    }
    .first-col-icon{
        margin-top:5vh;
        margin-bottom:5vh;
    }
    .first-col-icon svg{
     cursor: pointer;
    }
    #first-col-2{
        width:60vw;
        height:fit-content;
        padding-top:4vh;
    }
    .intro-text-1{
        color: #DAD7CD;
    font-family: Roboto;
    font-size: 48px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-left:3vw;
    }
    .intro-text-2{
        color: #588157;
    font-family: Roboto;
    font-size: 48px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-left:3vw;
    }
    .intro-name-1{
        color: #A3B18A;
    font-family: Roboto;
    font-size: 50px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top:-3.9vh;
    margin-left:3vw;
    margin-bottom:2.6vh;
    }
    .intro-name-2{
        color: #344E41;
    font-family: Roboto;
    font-size: 50px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top:-3.9vh;
    margin-left:3vw;
    margin-bottom:2.6vh;
    }
    .intro-name-3{
       color: #D4ADFC;color: #D4ADFC;
    font-family: Roboto;
    font-size: 50px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top:-3.9vh;
    margin-left:3vw;
    margin-bottom:2.6vh;
    }
    .intro-h3-1{
    margin-left:3vw;
    color: #DAD7CD;
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 250;
    line-height: normal;
    margin-top:1vh;
    margin-bottom:1vh;
    }
    .intro-h3-2{
    margin-left:3vw;
    color: #588157;
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 250;
    line-height: normal;
    margin-top:1vh;
    margin-bottom:1vh;
    }
    .first-btn1{
    background: #A3B18A;
    border-radius: 10px;
    width:43vw;
    height:6.5vh;
    margin-left:3vw;
    margin-top:2vh;
    cursor: pointer;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    display:flex;
    align-items:center;
    justify-content: center;
    }
    .first-btn1 h3{
        line-height: normal;
        color: #344E41;
        text-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        font-family: Inter;
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
    }
    .first-btn1 svg,
    .first-btn2 svg,
    .first-btn3 svg,
  .first-btn4 svg{
    margin-left:1.5vw;
    margin-top:0.5vh;
    }
    .first-btn2{
        background: #344E41;
        border-radius: 10px;
        width:43vw;
    height:6.5vh;
        margin-left:3vw;
        margin-top:2vh;
        cursor: pointer;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        display:flex;
    align-items:center;
    justify-content: center;
        }
        .first-btn2 h3{
            line-height: normal;
            color: #A3B18A;
            text-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);;
            font-family: Inter;
            font-size: 32px;
            font-style: normal;
            font-weight: 500;
        }
           .first-btn3{
        background: #D4ADFC;;
        border-radius: 10px;
        width:43vw;
    height:6.5vh;
        margin-left:3vw;
        margin-top:2vh;
        cursor: pointer;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        display:flex;
    align-items:center;
    justify-content: center;
        }
        .first-btn3 h3{
            line-height: normal;
            color: #1D267D;
            text-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);;
            font-family: Inter;
            font-size: 32px;
            font-style: normal;
            font-weight: 500;
        }
           .first-btn4{
        background: rgba(218, 215, 205, 0.70);
        border-radius: 10px;
        width:43vw;
    height:6.5vh;
        margin-left:3vw;
        margin-top:2vh;
        cursor: pointer;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        display:flex;
    align-items:center;
    justify-content: center;
        }
        .first-btn4 h3{
            line-height: normal;
            color: #0C134F;
            text-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);;
            font-family: Inter;
            font-size: 32px;
            font-style: normal;
            font-weight: 500;
        }
        
    #first-col3 img{
      width:250px;
      height:250px;
      border-radius: 400px;
      margin-left:-6vw;
      margin-top:10vh;
      animation: blobAnimation 3s ease-in-out infinite alternate;
    }
    @keyframes blobAnimation {
      0% {
        border-radius: 50% 50% 50% 50% / 30% 30% 60% 60%;
        transform: scale(0.8);
      }
      100% {
        border-radius:30% 70% 70% 30% / 30% 30% 70% 70%;
        transform: scale(0.9);
      }
    }
}
@media only screen and (min-width:961px){
#first-desk{
width:100vw;
position: relative;
height:fit-content;
overflow-x:hidden;
overflow-y:auto;
margin-top:6vh;
padding-top:8vh;
display: grid;
grid-template-columns: 15vw 45vw 40vw;
}
#first-desk::-webkit-scrollbar{
display: none;
}
#first-col1{
    width:15vw;
    height:fit-content;
    padding-left:6vw;
    padding-top:2vh;
}
.first-col-icon{
    margin-top:5vh;
    margin-bottom:5vh;
}
.first-col-icon svg{
 cursor: pointer;
}
#first-col-2{
    width:45vw;
    height:fit-content;
    padding-top:4vh;
}
.intro-text-1{
    color: #DAD7CD;
font-family: Roboto;
font-size: 48px;
font-style: normal;
font-weight: 400;
line-height: normal;
margin-left:6vw;
}
.intro-text-2{
    color: #588157;
font-family: Roboto;
font-size: 48px;
font-style: normal;
font-weight: 400;
line-height: normal;
margin-left:6vw;
}
.intro-name-1{
    color: #A3B18A;
font-family: Roboto;
font-size: 50px;
font-style: normal;
font-weight: 400;
line-height: normal;
margin-top:-3.9vh;
margin-left:6vw;
margin-bottom:2.6vh;
}
.intro-name-2{
    color: #344E41;
font-family: Roboto;
font-size: 50px;
font-style: normal;
font-weight: 400;
line-height: normal;
margin-top:-3.9vh;
margin-left:6vw;
margin-bottom:2.6vh;
}
.intro-name-3{
   color: #D4ADFC;
font-family: Roboto;
font-size: 50px;
font-style: normal;
font-weight: 400;
line-height: normal;
margin-top:-3.9vh;
margin-left:6vw;
margin-bottom:2.6vh;
}
.intro-h3-1{
margin-left:6vw;
color: #DAD7CD;
font-family: Inter;
font-size: 32px;
font-style: normal;
font-weight: 250;
line-height: normal;
width:30vw;
margin-top:1vh;
margin-bottom:1vh;
}
.intro-h3-2{
margin-left:6vw;
color: #588157;
font-family: Inter;
font-size: 32px;
font-style: normal;
font-weight: 250;
line-height: normal;
width:30vw;
margin-top:1vh;
margin-bottom:1vh;
}
.first-btn1{
background: #A3B18A;
border-radius: 10px;
width:23vw;
height:9vh;
margin-left:6vw;
margin-top:4vh;
cursor: pointer;
box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
display:flex;
align-items:center;
justify-content: center;
}
.first-btn1 h3{
    line-height: normal;
    color: #344E41;
    text-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    font-family: Inter;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
}
.first-btn1 svg,
.first-btn2 svg,
.first-btn3 svg,
.first-btn4 svg{
margin-left:1.5vw;
margin-top:0.5vh;
}
.first-btn2{
    background: #344E41;
    border-radius: 10px;
    width:23vw;
    height:9vh;
    margin-left:6vw;
    margin-top:4vh;
    cursor: pointer;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    display:flex;
align-items:center;
justify-content: center;
    }
    .first-btn2 h3{
        line-height: normal;
        color: #A3B18A;
        text-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);;
        font-family: Inter;
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
    }
#first-col3 img{
  width:400px;
  height:400px;
  border-radius: 400px;
  margin-left:2vw;
  margin-top:3vh;
  animation: blobAnimation 3s ease-in-out infinite alternate;
}
    .first-btn3{
        background: #D4ADFC;;
        border-radius: 10px;
    width:23vw;
    height:9vh;
    margin-left:6vw;
    margin-top:4vh;
    cursor: pointer;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    display:flex;
align-items:center;
justify-content: center;
        }
        .first-btn3 h3{
            line-height: normal;
            color: #1D267D;
             text-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);;
        font-family: Inter;
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        }
           .first-btn4{
        background: rgba(218, 215, 205, 0.70);
        border-radius: 10px;
    width:23vw;
    height:9vh;
    margin-left:6vw;
    margin-top:4vh;
    cursor: pointer;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    display:flex;
align-items:center;
justify-content: center;
        }
        .first-btn4 h3{
            line-height: normal;
            color: #0C134F;
             text-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);;
        font-family: Inter;
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        }
@keyframes blobAnimation {
  0% {
    border-radius: 50% 50% 50% 50% / 30% 30% 60% 60%;
    transform: scale(1);
  }
  100% {
    border-radius:30% 70% 70% 30% / 30% 30% 70% 70%;
    transform: scale(1.1);
  }
}
}


</style>